module.exports = __webpack_public_path__ + "static/media/training-icon.13415bf2.svg";